export default __webpack_public_path__ + "static/media/sticker-Z.5acc1117.png";